import { render } from "./BalTabs.vue?vue&type=template&id=1047feeb&scoped=true&ts=true"
import script from "./BalTabs.vue?vue&type=script&lang=ts"
export * from "./BalTabs.vue?vue&type=script&lang=ts"

import "./BalTabs.vue?vue&type=style&index=0&id=1047feeb&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1047feeb"]])

export default __exports__